import { cx } from '@emotion/css';
import type { FC, ReactNode } from 'react';

import { MotifComponent, useMotifStyles } from '../../motif';
import type { ImageSources } from '../../types';
import { ImageButton } from '../ImageButton';
import {
  authorCss,
  authorWithoutLogoCss,
  imageButtonContainerCss,
  longQuoteTextCss,
  quoteCss,
  quoteIconCss,
  quoteTextCss,
} from './QuoteV2.styled';

interface Props {
  author?: ReactNode;
  children?: ReactNode;
  imageSrc?: ImageSources;
  isRtl?: boolean;
  isLongQuote?: boolean;
}

export const QuoteV2: FC<Props> = ({
  author,
  children,
  imageSrc,
  isRtl = false,
  isLongQuote = false,
}) => {
  useMotifStyles(MotifComponent.QUOTE);

  // Add extra spacing when there's no logo
  const authorStylesWithSpacing = !imageSrc ? authorWithoutLogoCss : authorCss;
  const quoteTextStyles = isLongQuote ? longQuoteTextCss : quoteTextCss;
  const quoteIcon = isRtl ? '”' : '“';

  return (
    <div className={cx(MotifComponent.QUOTE, quoteCss)}>
      <div className={quoteIconCss}> {quoteIcon}</div>
      <div className={quoteTextStyles}>{children}</div>

      {imageSrc && (
        <div className={imageButtonContainerCss}>
          <ImageButton height={128} width={128} imgSrcs={imageSrc} altText="Quote background" />
        </div>
      )}

      {author && <div className={authorStylesWithSpacing}>{author}</div>}
    </div>
  );
};

QuoteV2.displayName = 'QuoteV2';
